/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsemptytitle2Inputs */

const en_groupsemptytitle2 = /** @type {(inputs: Groupsemptytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No group yet`)
};

const de_groupsemptytitle2 = /** @type {(inputs: Groupsemptytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Gruppe`)
};

/**
* | output |
* | --- |
* | "No group yet" |
*
* @param {Groupsemptytitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsemptytitle2 = /** @type {((inputs?: Groupsemptytitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsemptytitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsemptytitle2(inputs)
	return de_groupsemptytitle2(inputs)
});
export { groupsemptytitle2 as "groupsEmptyTitle" }